import { Device } from './Device';

export interface TaskInfo {
    id: number;
    deviceID: number;
    clientID: string;
    priority: TaskPriority;
    createDate: Date;
    expireDate: Date;
    type: TaskType;
    action: string;
    payload: string;
    result: string;
    device: Device;
    lastModifiedDate: Date;
  }

export enum TaskPriority {
    high = 1,
    medium = 2,
    low = 3
  }

export enum TaskType {
    all = 0,
    command = 1,
    alive = 2,
    action = 3,
    sendfile = 4
  }
